import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GatewayAuth } from '../models/response/gateway-auth-response';
import { map } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import { LocalStoreKeys } from '../shared/helpers/localstorage/local-store';

@Injectable({
  providedIn: 'root'
})
export class GatewayAuthService {

  private URL = environment.GATEWAY + 'auth/token';

  private gatewayUserSubject: BehaviorSubject<GatewayAuth>;
  public gatewayUser: Observable<GatewayAuth>;

  constructor(private http: HttpClient) {
    this.gatewayUserSubject = new BehaviorSubject<GatewayAuth>(JSON.parse(localStorage.getItem(LocalStoreKeys.gatewayUser)));
    this.gatewayUser = this.gatewayUserSubject.asObservable();
  }

  public get gatewayUserValue(): GatewayAuth {
    return this.gatewayUserSubject.value;
  }

  setCurrentUserValue(newGatewayUser: GatewayAuth) {
    localStorage.setItem(LocalStoreKeys.gatewayUser, JSON.stringify(newGatewayUser));
    this.gatewayUserSubject.next(newGatewayUser);
  }

  public authenticate(document: string, password: string) {
    return this.http.post<GatewayAuth>(this.URL, {document, password})
    .pipe(map(
      response => {
          localStorage.setItem(LocalStoreKeys.gatewayUser , JSON.stringify(response));
          this.gatewayUserSubject.next(response);
          return response;
      }
    ));
  }
}
